<!-- 地图 -->
<style lang="stylus" scoped>
.center {
  height: 60vh;
  padding: 0.5vh;
  background-size: 100% 100%;

  .describe {
    margin-top: 5vh;
    color: #fff;
    text-align: center;

    .left, .right {
      width: 50%;
      float: left;
    }

    .title {
      width: 14.3vh;
      height: 4.2vh;
      line-height: 4.2vh;
      margin: 2vh auto;
      background: rgba(8, 26, 84, 0);
      border: 1px solid rgba(0, 96, 255, 1);
      box-shadow: inset 0px 0px 30px 0px rgba(0, 96, 255, 0.5);
      font-size: 2vh;
      font-weight: bold;
    }

    .detail {
      display: flex;

      .item {
        width: 100%;

        P {
          margin-bottom: 1vh;
        }

        .name {
          font-size: 1.8vh;
          font-weight: bold;
        }

        .num {
          color: #FFDD01;
          font-size: 1.8vh;
          font-weight: bold;

          span {
            font-size: 12px;
            font-weight: 400;
            color: #fff;
          }
        }

        .percent {
          font-size: 1.6vh;
          font-weight: 400;
          color: #EF850E;

          &:after {
            display: inline-block;
            content: '';
            width: 1vh;
            height: 1.1vh;
            margin-left: 0.5vh;
          }
        }

        .percent1 {
          font-size: 1.6vh;
          font-weight: 400;
          color: #00fefb;

          &:after {
            display: inline-block;
            content: '';
            width: 1vh;
            height: 1.1vh;
            margin-left: 0.5vh;
          }
        }
      }
    }
  }

  .map {
    width: 100%;
    height: 60vh;
    margin: 0 auto;
    background: url('../../../../../assets/img/dashboard/map.png');
    background-size: 100% 100%;
    margin-top: 20vh;

    .name {
      font-size: 2.4vh;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 1.3vh;
      padding-top: 3vh;

      &:before {
        display: block;
        content: '';
        width: 0.8vh;
        height: 2.4vh;
        background: #FFF;
        float: left;
        margin-top: -0.5vh;
        margin-left: 3vh;
        margin-right: 1vh;
        background-size: 100% 100%;
      }
    }

    .table {
      height: 55vh;
      width: 100%;

      color: #fff;
      text-align: center;

      // border: 1px solid green;
      .line {
        height: 55vh;

        .main {
          width: 100%;
          height: 100%;
        }
      }
    }

    .right {
      width: 200px;
      height: 600px;
      background: red;
      float: right;
      transform: rotate(-20deg);

      ul {
        li {
          width: 106px;
          height: 30px;
          background: rgba(14, 75, 159, 1);
          border: 1px solid rgba(143, 243, 255, 0.73);
          text-align: center;
          line-height: 30px;
          color: #FFf;
        }
      }
    }
  }
}
</style>



<template>
  <div>
    <div class="center">
      <div class="describe">
        <div class="left">
          <div class="title">销售额</div>
          <div class="detail">
            <div class="item">
              <p class="num">{{ this.salesAmount }}</p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">订单客户</div>
          <div class="detail">
            <div class="item">
              <p class="num">{{ this.orderCustomer }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="map">
        <div class="name">销售数据</div>
        <div class="table">
          <div class="line">
            <div class="main"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  props: ["orderCustomer", "salesAmount", "salesDataBar"],
  data() {
    return {
      name: '',
      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
      dataX: [],
      dataY: []
    }
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.setOption({
        animation: true,
        grid: {
          top: '10%',
          left: '15%',
          bottom: '15%'
        },
        xAxis: {
          data: this.dataX,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: "#fff",
            fontSize: 12,
            rotate: 30
          }
        },
        yAxis: {
          name: '',
          nameTextStyle: {
            color: "#fff",
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#fff",
            fontSize: 12,
            formatter: function (value) {
              // if (value > 1000000) {
              //   return value / 1000000 + "百万"
              // } else
              if (value > 10000) {
                return value / 10000 + "万"
              } else {
                return value
              }
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0177d4"
            }
          }
        },
        series: [
          {
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#ffb52a'
                },
                {
                  offset: 1,
                  color: '#ffb52a'
                }
                ], false)
              }
            },
            itemStyle: {
              color: "red",
              borderColor: "#fff",
              borderWidth: 10
            },
            areaStyle: {
              normal: {
                color: '#3fbbff0d'
              }
            },
            data: this.dataY
          }
        ]
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    for (var i = 0; i < this.salesDataBar.length; i++) {
      this.dataY.push(this.salesDataBar[i].lumpSum)
      this.dataX.push(this.salesDataBar[i].month)
    }
    var dataArr = [];
    var data = new Date();
    var year = data.getFullYear();
    data.setMonth(data.getMonth() + 1, 1)
    for (var k = 0; k < 12; k++) {
      data.setMonth(data.getMonth() - 1);
      var m = data.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      dataArr.push(data.getFullYear() + "-" + (m))
    }
    this.dataX = dataArr.reverse()
    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      // 某些定时器操作
      self.getData()
    }, 3000);
  }
}
</script>





// WEBPACK FOOTER //
// index.vue?aa71a73a